import React from 'react';
import { CATASTRO_FIELDS, initialFieldDecisions, labelField, textValue } from './ReviewFields';

const MONEY = new Set(['precio_compra', 'precio_compra_estimado', 'deuda_total', 'deuda_reclamada', 'principal', 'intereses', 'costas', 'valor_subasta', 'tasacion', 'valor_adjudicacion', 'valor_referencia', 'valor_salida_base', 'cargas', 'ibi_pendiente', 'comunidad_pendiente']);
const TYPES = { CREDITO: 'Crédito', REMATE: 'Remate', SUBASTA: 'Subasta', OCUPADO: 'Ocupado', REO: 'REO', COMPRA_DIRECTA: 'Compra directa' };
const euros = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 2 });

export const proposedChanges = row => Object.entries(row.cambios || {})
  .filter(([field, value]) => (row.aplicar_datos_validos || !CATASTRO_FIELDS.has(field)) && value != null && typeof value !== 'object' && typeof value !== 'boolean')
  .map(([field, after]) => ({ field, before: row.antes?.[field] ?? row.valores_existentes?.[field] ?? row.expected?.[field], after }))
  .sort((a, b) => ({ precio_compra: 0, tipo_activo_operativo: 1 }[a.field] ?? 2) - ({ precio_compra: 0, tipo_activo_operativo: 1 }[b.field] ?? 2));

export const changeValue = (field, value, operation) => {
  if (value == null || value === '') return 'Sin dato';
  if (field === 'tipo_activo_operativo') return TYPES[value] || textValue(value);
  if (field === 'servicer_id' && value === operation.perimetro?.servicer_id) return operation.servicer_nombre;
  if (MONEY.has(field)) {
    const numeric = typeof value === 'number' || /^-?\d+(?:[.,]\d{1,2})?$/.test(String(value));
    return numeric && Number.isFinite(Number(String(value).replace(',', '.'))) ? euros.format(Number(String(value).replace(',', '.'))) : `${value} €`;
  }
  return textValue(value);
};

export const quickDecisions = row => {
  const initial = initialFieldDecisions(row);
  return Object.fromEntries(proposedChanges(row).map(({ field, after }) => [field, initial[field] || {
    accion: 'confirmar', valor: row.incoming?.[field] ?? after, motivo: 'Propuesta aceptada desde el listado de revisión',
  }]));
};

export const proposalsAccepted = row => {
  const changes = proposedChanges(row);
  return changes.length > 0 && changes.every(({ field }) => ['confirmar', 'editar'].includes(row.ajustes?.campos?.[field]?.accion));
};

export const canAcceptFromList = row => row.registro_tipo === 'archivo' && row.existente && row.can_apply && proposedChanges(row).length > 0 && !(row.incidencias || []).some(i => i.estado === 'pendiente');

export const ReviewChanges = ({ row, operation }) => {
  if (!row.existente || row.registro_tipo !== 'archivo') return null;
  const changes = proposedChanges(row);
  if (!changes.length) return null;
  return <ul className="mt-3 space-y-1 text-sm" data-testid={`review-row-${row.ordinal}-changes`}>
    {changes.map(({ field, before, after }) => <li key={field} className="break-words" data-testid={`review-row-${row.ordinal}-change-${field}`}>
      <span className="font-medium">{field === 'precio_compra' ? 'Precio' : labelField(field)}: </span>
      <span className="opacity-70" data-testid={`review-row-${row.ordinal}-before-${field}`}>{changeValue(field, before, operation)}</span>
      <span aria-label="cambia a"> → </span>
      <span className="font-semibold" data-testid={`review-row-${row.ordinal}-after-${field}`}>{changeValue(field, after, operation)}</span>
    </li>)}
  </ul>;
};